@if (saving()) {
    <div class="spinner-container">
        <mat-spinner diameter="24" />
    </div>
}

<ng-content />

@if (arrow() === 'right') {
    <stby-icon class="secondary-arrow secondary-arrow-right" icon="arrow-right" />
}

@if (arrow() === 'left') {
    <stby-icon class="secondary-arrow secondary-arrow-left" icon="back" />
}
